import Axios from 'axios';
import { ITC_PARAMS_URL, MARKETPLACE_PARAMS_URL, PARAMS_URL } from '../constants/url';
import {
    ITC_PARAMS_FETCH_ERROR,
    ITC_PARAMS_FETCH_IN_PROGRESS,
    ITC_PARAMS_FETCH_SUCCESS,
    MARKETPLACE_PARAMS_FETCH_ERROR,
    MARKETPLACE_PARAMS_FETCH_IN_PROGRESS,
    MARKETPLACE_PARAMS_FETCH_SUCCESS,
    PARAMS_FETCH_ERROR,
    PARAMS_FETCH_IN_PROGRESS,
    PARAMS_FETCH_SUCCESS,
} from '../constants/params';
import { handleErrorMessage } from '../utils/errorMessages';

const fetchParamsInProgress = () => {
    return {
        type: PARAMS_FETCH_IN_PROGRESS,
    };
};

const fetchParamsSuccess = (value) => {
    return {
        type: PARAMS_FETCH_SUCCESS,
        value,
    };
};

const fetchParamsError = (message) => {
    return {
        type: PARAMS_FETCH_ERROR,
        message,
    };
};

export const fetchParams = (cb) => (dispatch) => {
    dispatch(fetchParamsInProgress());

    Axios.get(PARAMS_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchParamsSuccess(res.data && res.data.params));
            if (cb) {
                cb(res.data && res.data.params);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchParamsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchITCParamsInProgress = () => {
    return {
        type: ITC_PARAMS_FETCH_IN_PROGRESS,
    };
};

const fetchITCParamsSuccess = (value) => {
    return {
        type: ITC_PARAMS_FETCH_SUCCESS,
        value,
    };
};

const fetchITCParamsError = (message) => {
    return {
        type: ITC_PARAMS_FETCH_ERROR,
        message,
    };
};

export const fetchITCParams = (cb) => (dispatch) => {
    dispatch(fetchITCParamsInProgress());

    Axios.get(ITC_PARAMS_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchITCParamsSuccess(res.data && res.data.params));
            if (cb) {
                cb(res.data && res.data.params);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchITCParamsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchMarketPlaceParamsInProgress = () => {
    return {
        type: MARKETPLACE_PARAMS_FETCH_IN_PROGRESS,
    };
};

const fetchMarketPlaceParamsSuccess = (value) => {
    return {
        type: MARKETPLACE_PARAMS_FETCH_SUCCESS,
        value,
    };
};

const fetchMarketPlaceParamsError = (message) => {
    return {
        type: MARKETPLACE_PARAMS_FETCH_ERROR,
        message,
    };
};

export const fetchMarketPlaceParams = (cb) => (dispatch) => {
    dispatch(fetchMarketPlaceParamsInProgress());

    Axios.get(MARKETPLACE_PARAMS_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchMarketPlaceParamsSuccess(res.data && res.data.params));
            if (cb) {
                cb(res.data && res.data.params);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchMarketPlaceParamsError(message));

            if (cb) {
                cb(null);
            }
        });
};
